export default class CourseMenu {
  constructor(canteen, date, course, meals) {
    this.canteen = canteen;
    this.date    = date;
    this.course  = course;
    this.meals   = meals;
  }
}
